var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "fc9201e412ab93717978668be1d6cfb25af896b3"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["disivo@disivo-sro"] = {
  id: "fc9201e412ab93717978668be1d6cfb25af896b3"
};